// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1PFB0","content":"styles_content__2y0VW","intro":"styles_intro__7IUyl"};